export default {
    loggedIn: state => state.loggedIn,
    token: state => state.token
}
